/** Up to two uppercase initials from a display name, else the email local-part. */
export function getInitials(name: string | undefined, email: string): string {
  const words = name?.trim().split(/\s+/).filter(Boolean) ?? [];
  if (words.length > 0) {
    return words
      .slice(0, 2)
      .map((word) => word[0])
      .join('')
      .toUpperCase();
  }
  return email.split('@')[0].slice(0, 2).toUpperCase();
}

/**
 * Auth0's `cdn.auth0.com/avatars/*.png` images are just generated initials,
 * loaded cross-origin and setting a third-party cookie. Drop them so the UI
 * renders an identical initials avatar client-side; keep real provider/uploaded
 * photos untouched.
 */
export function resolveAvatarSrc(picture: string | undefined): string | undefined {
  if (!picture) return undefined;
  if (picture.includes('cdn.auth0.com')) return undefined;
  return picture;
}
